import React from 'react';
import { ChartBarIcon } from '@heroicons/react/24/solid';

const StatsChartPlaceholder = ({ onClick }) => (
  <div
    onClick={onClick}
    className="tw-mt-2 tw-p-2 tw-bg-gray-50 tw-border tw-border-gray-200 tw-rounded-lg tw-flex tw-items-center tw-gap-2 tw-cursor-pointer hover:tw-bg-gray-100 tw-transition-colors"
  >
    <ChartBarIcon className="tw-w-4 tw-h-4 tw-text-gray-400" />
    <span className="tw-text-xs tw-text-gray-500">Click to expand and view charts</span>
  </div>
);

export default StatsChartPlaceholder;
